<template>
    <div>
        <div>
            <div class="grid grid-cols-12 gap-2 mb-4">
                <div class="col-span-4">
                    <ui-toggle class="p-2 rounded-xl bg-gray-100" field="text-lg text-gray-900"
                               text="Show Materials"
                               v-model="breakdown.materials"></ui-toggle>
                </div>
                <div class="col-span-4">
                    <ui-toggle class="p-2 rounded-xl bg-gray-100" field="text-lg text-gray-900"
                               text="Show Labour"
                               v-model="breakdown.labour"></ui-toggle>
                </div>
                <div class="col-span-4">
                    <ui-toggle class="p-2 rounded-xl bg-gray-100" field="text-lg text-gray-900"
                               text="Show Fixed Costs"
                               v-model="breakdown.fixedCosts"></ui-toggle>
                </div>
            </div>
        </div>
        <div>
            <ui-select-searchable :options="contextOptions" label="Context"
                                  v-model="contextCode"></ui-select-searchable>
        </div>
        <resource-planning-report-budget-by-source
            v-if="breakdown.materials"
            :resource-planning-report="resourcePlanningReport"
            :context-code="contextCode" :type="'material'"></resource-planning-report-budget-by-source>
        <resource-planning-report-budget-by-source
            v-if="breakdown.labour"
            :resource-planning-report="resourcePlanningReport"
            :context-code="contextCode" :type="'labour'"></resource-planning-report-budget-by-source>
        <resource-planning-report-budget-by-source
            v-if="breakdown.fixedCosts"
            :resource-planning-report="resourcePlanningReport"
            :context-code="contextCode" :type="'fixedCost'"></resource-planning-report-budget-by-source>
    </div>
</template>

<script>

import UiToggle from "../ui/UiToggle.vue";
import {resolveNumericText, toCurrency, uuid} from "../../utils";
import {ResourcePlanningReport} from "@models";
import ResourcePlanningReportMaterialItem from "./ResourcePlanningReportMaterialItem.vue";
import ResourcePlanningReportBudget from "./ResourcePlanningReportBudget.vue";
import UiSelectSearchable from "../ui/UiSelectSearchable.vue";
import ResourcePlanningReportBudgetBySource from "./ResourcePlanningReportBudgetBySource.vue";

export default {
    components: {
        ResourcePlanningReportBudgetBySource,
        UiSelectSearchable,
        ResourcePlanningReportBudget,
        ResourcePlanningReportMaterialItem,
        UiToggle,
    },
    props: {
        resourcePlanningReport: null,
    },
    data() {
        return {
            resolveNumericText,
            breakdown: {
                materials: false,
                labour: true,
                fixedCosts: false,
            },
            viewByComponent: false,
            contextCode: {'label': '-> Entire contract', 'value': 'contract'},
        };
    },
    computed: {
        contextOptions() {
            let options = [{'label': '-> Entire contract', 'value': 'contract'}]
            this.resourcePlanningReport.sections.forEach(section => {
                options.push({'label': '    -> ' + section.name, 'value': 'section|' + section.id});
                section.tasks.forEach(task => {
                    options.push({
                        'label': '       -> ' + (task.reference ? task.reference + ' - ' : '') + task.name,
                        'value': 'task|' + task.id
                    });
                    task.items.forEach(item => {
                        options.push({
                            'label': '         -> ' + (item.reference ? item.reference + ' - ' : '') + item.description,
                            'value': 'item|' + item.id
                        });
                    })
                })
            })
            return options
        },
    },
    methods: {
        async updateLatest() {
        },
    },
    async mounted() {
    }
};
</script>
